import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserStateService} from "../user/user.state.service";
import {User} from "../user/user";
import {Subscription} from "rxjs";
import {NavStatusService} from '../nav-status.service';
import {NavigationPoint} from '../navigation-point';
import {ThemeService} from '../common/theme.service';
import {UserService} from '../user/user.service';
import {StaticTile} from './static-tile';
import {FullHeighDirective} from '../common/full-heigh.directive';
import {FilterStateService} from "../dam-header/filter-state.service";
import {QuickLink} from "./quick-link";
import {NgStyle} from "@angular/common";

@Component({
    selector: 'app-home',
    imports: [
        FullHeighDirective,
        NgStyle,
    ],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, OnDestroy {

    userSub: Subscription | undefined;
    themeSubscription: Subscription | undefined;
    user: User | null = null;
    theme: string | undefined;
    staticTiles: StaticTile[] = [];
    quickLinks: QuickLink [] = [];
    userCalled: boolean = false;
    userCalledSubscription: Subscription | undefined;

    constructor(
        private userStateService: UserStateService,
        private navStatusService: NavStatusService,
        private themeService: ThemeService,
        private userService: UserService,
        private filterStateService: FilterStateService
    ) {
    }

    ngOnInit(): void {
        this.userCalledSubscription = this.userStateService.userCallReady.subscribe(res => {
            this.userCalled = res;
            this.checkContentToLoad();
        })
        this.userSub = this.userStateService.user$.subscribe(user => {
            this.user = user;
          this.checkContentToLoad();
        });
        this.themeSubscription = this.themeService.theme$.subscribe(theme => {
            if (theme) {
                this.theme = theme;
            }
        })
        this.filterStateService.setShowFilterBar(false);
        this.navStatusService.setActiveNavPoint(NavigationPoint.home);
    }
    checkContentToLoad(): void {
        if (this.user && this.userCalled) {
            this.loadQuickLinks();
        }
        if (!this.user && this.userCalled) {
            this.loadStaticUserContent()
        }
    }
    loadQuickLinks(): void {
       // console.log("Loading Quick Links...");
        this.userService.getQuickLinks().subscribe(links => {
           this.quickLinks = links.data;
        })
    }
    loadStaticUserContent() {
        this.userService.getAnonUserContent().subscribe(res => {
           // console.log('content', res);
            if (this.theme) {
                if (res.hasOwnProperty(this.theme)) {
                    // const data = res[this.theme];
                    // @ts-ignore
                    this.parseTiles(res[this.theme]);
                }
            }

        })
    }
    parseTiles(data: any) {
        this.staticTiles = [];
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                const tile: StaticTile = {
                    name: key,
                    url: data[key],
                    image: this.getImageFromName(key),
                }
                this.staticTiles.push(tile);
            }
        }
    }
    getImageFromName($image: string): string {
       let img: string = $image.toLowerCase();
        img = img.split(' ').join('-');
        img =  img.split('&').join('and');
        if (this.theme !== 'head') {
            img = this.theme + '_' + img
        }
       return '/images/bynder/' + img + '.jpg';
    }

    ngOnDestroy(): void {
        if (this.userSub) {
            this.userSub.unsubscribe();
        }
        if (this.themeSubscription) {
            this.themeSubscription.unsubscribe();
        }
    }
    setUpNoneUserContent() {

    }


}
